/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_HintInputs */

const cs_portals_hint = /** @type {(inputs: Portals_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikace na webu a sync na portály jsou oddělené. Skrýt stáhne web a odebere zapnuté portály. Fotky berou ze záložky Média (první = cover).`)
};

const en_portals_hint = /** @type {(inputs: Portals_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website publish and portal sync are separate. Unpublish hides the website and removes enabled portals. Photos come from the Media tab (first = cover).`)
};

/**
* | output |
* | --- |
* | "Website publish and portal sync are separate. Unpublish hides the website and removes enabled portals. Photos come from the Media tab (first = cover)." |
*
* @param {Portals_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_hint = /** @type {((inputs?: Portals_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_hint(inputs)
	return cs_portals_hint(inputs)
});